<template>
  <div class="row">
    <div class="col-12">
      <biz-location-table />
    </div>
  </div>
</template>

<script>
import BizLocationTable from "@/views/components/bizLocations/table";
export default {
  name: "BizLocationList",
  components: { BizLocationTable },
};
</script>
